import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem } from '@mui/material';
import { genderOptions } from '../config/select';
import { CommonSelect } from 'component/select';
import { t } from 'i18next';

/**
 * A functional component that renders a selector for choosing a gender option.
 */
export const GenderSelector = ({ values, handleChange }) => {
    return (
        <FormControl fullWidth>
            <InputLabel id="gender-label">{t('users.fields.gender')}</InputLabel>
            <CommonSelect
                id="gender-label"
                name="gender"
                label={t('users.fields.gender')}
                value={values.gender}
                onChange={handleChange}
                renderValue={(selected) => selected?.name || ''}
            >
                {genderOptions.map((option) => (
                    <MenuItem key={option.value} value={option}>
                        {option.name}
                    </MenuItem>
                ))}
            </CommonSelect>
        </FormControl>
    );
};

GenderSelector.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
